import React, { createContext, useContext } from "react";
import { FlagProvider } from "@unleash/proxy-client-react";
import UnleashUserContext from "./UnleashUserContext";

const unleashConfig = {
  url: process.env.REACT_APP_UNLEASH_URL || "",
  clientKey: process.env.REACT_APP_UNLEASH_CLIENT_KEY || "",
  refreshInterval: 15,
  appName: process.env.REACT_APP_UNLEASH_APP_NAME || "msk-web-app",
};

const UnleashConfiguredContext = createContext(false);

export function useUnleashConfigured(): boolean {
  return useContext(UnleashConfiguredContext);
}

function UnleashProvider({ children }: { children: React.ReactNode }) {
  if (!unleashConfig.clientKey || !unleashConfig.url) {
    return (
      <UnleashConfiguredContext.Provider value={false}>
        {children}
      </UnleashConfiguredContext.Provider>
    );
  }
  return (
    <UnleashConfiguredContext.Provider value={true}>
      <FlagProvider config={unleashConfig}>
        <UnleashUserContext />
        {children}
      </FlagProvider>
    </UnleashConfiguredContext.Provider>
  );
}

export default UnleashProvider;
